export type PageTitleProps = { title: string };

const PageTitle = ({ title }: PageTitleProps) => (
	<h1 className='text-lg md:text-lg xl:text-2xl 2xl:text-3xl font-bold font-serif mb-6 text-center'>
		{title}
	</h1>
);

export default PageTitle;
